export const COIN_THRESHOLD = 50;
